// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  Count,
  CountFromJSON,
  CountToJSON,
  DefaultResponseError,
  DefaultResponseErrorFromJSON,
  DefaultResponseErrorToJSON,
  ForbiddenError,
  ForbiddenErrorFromJSON,
  ForbiddenErrorToJSON,
  IssueComment,
  IssueCommentFromJSON,
  IssueCommentToJSON,
  IssueCommentPayload,
  IssueCommentPayloadFromJSON,
  IssueCommentPayloadToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface AddIssueCommentRequest {
  issueCommentPayload?: IssueCommentPayload;
}

export interface DeleteIssueCommentRequest {
  id: number;
  project: number;
}

export interface GetIssueCommentRequest {
  id: number;
  project: number;
}

export interface GetIssueCommentsRequest {
  issue: number;
  project: number;
  limit?: number;
  start?: number;
  sort?: string;
  filter?: string;
}

export interface GetIssueCommentsCountRequest {
  project: number;
  issue: number;
}

export interface UpdateIssueCommentRequest {
  id: number;
  issueCommentPayload?: IssueCommentPayload;
}

/**
 * no description
 */
export class IssueCommentsApi extends runtime.BaseAPI {
  /**
   * Adds a new comment on an issue
   * Add issue comment
   */
  async addIssueCommentRaw(
    requestParameters: AddIssueCommentRequest
  ): Promise<runtime.ApiResponse<IssueComment>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/issuecomments`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: IssueCommentPayloadToJSON(requestParameters.issueCommentPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      IssueCommentFromJSON(jsonValue)
    );
  }

  /**
   * Adds a new comment on an issue
   * Add issue comment
   */
  async addIssueComment(
    requestParameters: AddIssueCommentRequest
  ): Promise<IssueComment> {
    const response = await this.addIssueCommentRaw(requestParameters);
    return await response.value();
  }

  /**
   * Delete a specific comment on an issue (creator only, within 5-minute window)
   * Delete issue comment
   */
  async deleteIssueCommentRaw(
    requestParameters: DeleteIssueCommentRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteIssueComment."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling deleteIssueComment."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/issuecomments/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Delete a specific comment on an issue (creator only, within 5-minute window)
   * Delete issue comment
   */
  async deleteIssueComment(
    requestParameters: DeleteIssueCommentRequest
  ): Promise<any> {
    const response = await this.deleteIssueCommentRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get a specific comment on an issue
   * Get issue comment
   */
  async getIssueCommentRaw(
    requestParameters: GetIssueCommentRequest
  ): Promise<runtime.ApiResponse<IssueComment>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getIssueComment."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getIssueComment."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/issuecomments/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      IssueCommentFromJSON(jsonValue)
    );
  }

  /**
   * Get a specific comment on an issue
   * Get issue comment
   */
  async getIssueComment(
    requestParameters: GetIssueCommentRequest
  ): Promise<IssueComment> {
    const response = await this.getIssueCommentRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get comments for a specific issue
   * Get issue comments
   */
  async getIssueCommentsRaw(
    requestParameters: GetIssueCommentsRequest
  ): Promise<runtime.ApiResponse<Array<IssueComment>>> {
    if (
      requestParameters.issue === null ||
      requestParameters.issue === undefined
    ) {
      throw new runtime.RequiredError(
        "issue",
        "Required parameter requestParameters.issue was null or undefined when calling getIssueComments."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getIssueComments."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.issue !== undefined) {
      queryParameters["issue"] = requestParameters.issue;
    }

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/issuecomments`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(IssueCommentFromJSON)
    );
  }

  /**
   * Get comments for a specific issue
   * Get issue comments
   */
  async getIssueComments(
    requestParameters: GetIssueCommentsRequest
  ): Promise<Array<IssueComment>> {
    const response = await this.getIssueCommentsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get count of comments for a specific issue
   * Get issue comments count
   */
  async getIssueCommentsCountRaw(
    requestParameters: GetIssueCommentsCountRequest
  ): Promise<runtime.ApiResponse<Count>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getIssueCommentsCount."
      );
    }

    if (
      requestParameters.issue === null ||
      requestParameters.issue === undefined
    ) {
      throw new runtime.RequiredError(
        "issue",
        "Required parameter requestParameters.issue was null or undefined when calling getIssueCommentsCount."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.issue !== undefined) {
      queryParameters["issue"] = requestParameters.issue;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/issuecomments/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Get count of comments for a specific issue
   * Get issue comments count
   */
  async getIssueCommentsCount(
    requestParameters: GetIssueCommentsCountRequest
  ): Promise<Count> {
    const response = await this.getIssueCommentsCountRaw(requestParameters);
    return await response.value();
  }

  /**
   * Update an issue comment (creator only, within 5-minute window)
   * Updates an issue comment
   */
  async updateIssueCommentRaw(
    requestParameters: UpdateIssueCommentRequest
  ): Promise<runtime.ApiResponse<IssueComment>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateIssueComment."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/issuecomments/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: IssueCommentPayloadToJSON(requestParameters.issueCommentPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      IssueCommentFromJSON(jsonValue)
    );
  }

  /**
   * Update an issue comment (creator only, within 5-minute window)
   * Updates an issue comment
   */
  async updateIssueComment(
    requestParameters: UpdateIssueCommentRequest
  ): Promise<IssueComment> {
    const response = await this.updateIssueCommentRaw(requestParameters);
    return await response.value();
  }
}
